import { Routes } from '@angular/router';
import { RolesPageComponent } from './containers/roles-page/roles-page.component';

export const ROLES_ROUTES: Routes = [
  {
    path: '',
    component: RolesPageComponent,
  },
];
